<script>
	import FormRow from "../../../components/FormRow.svelte";
	import FormColumn from "../../../components/FormColumn.svelte";
	import FormRowColumn from "../../../components/FormRowColumn.svelte";
	import TextInput from "../../../components/TextInput.svelte";
	import Checkbox from "../../../components/Checkbox.svelte";

	export let model = {};
	export let disabled = false;

	const handleVerbalConfirmationChange = async (e) => {
		if (e.target.checked) {
			model.claimantSignature = "VERBAL DECLARATION PROVIDED";
		} else {
			model.claimantSignature = null;
		}
	};

	if (!disabled) {
		if (model.formCompletionType != "Assisted" || model.assistant?.emailAddress?.indexOf("@shine.com.au") < 0) {
			model.verbalConfirmationGiven = false;
			if (model.claimantSignature == "VERBAL DECLARATION PROVIDED") {
				model.claimantSignature = null;
			}
		} else {
			model.promiseInformationTrue = false;
			model.consentToAcceptance = false;
			if (model.claimantSignature != "VERBAL DECLARATION PROVIDED") {
				model.claimantSignature = model.verbalConfirmationGiven ? "VERBAL DECLARATION PROVIDED" : null;
			}
		}
	}
</script>

{#if disabled}
	{#if model.verbalConfirmationGiven}
		<FormRowColumn>
			<Checkbox
				{disabled}
				required="true"
				bind:checked={model.verbalConfirmationGiven}
				label="I confirm the Registration Form has been read to the registrant and they have provided a verbal declaration that the information provided in the Registration Form (including attachments) is true and they understand lying may be a criminal offence."
				id="verbalConfirmationGiven"
			></Checkbox>
		</FormRowColumn>
	{/if}
	{#if model.promiseInformationTrue}
		<FormRowColumn>
			<Checkbox
				{disabled}
				required="true"
				bind:checked={model.promiseInformationTrue}
				label="I promise that the information provided in this Registration Form (including attachments) is true and I understand that lying may be a criminal offence."
				id="promiseInformationTrue"
			></Checkbox>
		</FormRowColumn>
	{/if}
	{#if model.consentToAcceptance}
		<FormRowColumn>
			<Checkbox
				{disabled}
				required="true"
				bind:checked={model.consentToAcceptance}
				label="I expressly consent to this method of acceptance in accordance with the Electronic Transactions (Northern Territory) Act 2000 s(9)."
				id="consentToAcceptance"
			></Checkbox>
		</FormRowColumn>
	{/if}
{:else if model.formCompletionType == "Assisted" && model.assistant?.emailAddress?.indexOf("@shine.com.au") > 0}
	<FormRowColumn>
		<Checkbox
			{disabled}
			on:change={handleVerbalConfirmationChange}
			required="true"
			bind:checked={model.verbalConfirmationGiven}
			label="I confirm the Registration Form has been read to the registrant and they have provided a verbal declaration that the information provided in the Registration Form (including attachments) is true and they understand lying may be a criminal offence."
			id="verbalConfirmationGiven"
		></Checkbox>
	</FormRowColumn>
{:else}
	<FormRowColumn>
		<Checkbox
			{disabled}
			required="true"
			bind:checked={model.promiseInformationTrue}
			label="I promise that the information provided in this Registration Form (including attachments) is true and I understand that lying may be a criminal offence."
			id="promiseInformationTrue"
		></Checkbox>
	</FormRowColumn>

	<FormRowColumn>
		<Checkbox
			{disabled}
			required="true"
			bind:checked={model.consentToAcceptance}
			label="I expressly consent to this method of acceptance in accordance with the Electronic Transactions (Northern Territory) Act 2000 s(9)."
			id="consentToAcceptance"
		></Checkbox>
	</FormRowColumn>
{/if}

<FormRow>
	<FormColumn cols="8">
		<TextInput
			disabled={disabled || model.verbalConfirmationGiven}
			required={model.formCompletionType != "Assisted" ||
				model.assistant?.emailAddress?.indexOf("@shine.com.au") < 0}
			label="Claimant's signature"
			bind:value={model.claimantSignature}
		/>
	</FormColumn>
	<FormColumn cols="4">
		<TextInput disabled label="Date" bind:value={model.dateClaimantSignature} />
	</FormColumn>
</FormRow>
